import { getUserError } from '../../../../components/miscUtils';
import { TpExpressionContext, evalExpression } from '../../../../components/safeExpressions';
import { jsonReplaceDbActionVariables } from '../helpers/jsonReplaceVariables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';
import {
  addFunctionsToExpressionContext,
  defaultExpressionFunctionsList,
  getExpressionFunctionsDescription,
} from './dbActionStepTypeCalculateVariable';
import { stepDefinitionMap } from './stepsFactory';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'Condition',
    description: 'Executed a series of steps only if a condition was met.',
    properties: {
      type: { type: 'string', const: 'Condition' },
      expression: {
        type: 'string',
        description: `Expression to be evaluated. The conditional steps will only be executed if this evalues to true.
Special functions: ${getExpressionFunctionsDescription(defaultExpressionFunctionsList)}.`,
      },
      steps: {
        type: 'array',
        items: {
          type: 'object',
          description: 'Each step should have the same format as a top level step in the action',
        },
        description: `Set of steps to be conditionally executed.`,
      },
    },
    required: ['type', 'expression', 'steps'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const parameters: { [id: string]: any } = {};
  for (const variabName in ctx.variables) parameters['$' + variabName] = ctx.variables[variabName].content;
  const expr: TpExpressionContext = {
    expressionString: step.expression,
    parameters,
  };
  addFunctionsToExpressionContext(expr, defaultExpressionFunctionsList);

  const subSteps = step.steps;
  function executeCurrentSubStep(ctx: TpDashboardActionContext, currentSubstepNr: number) {
    if (currentSubstepNr >= subSteps.length) {
      onCompleted();
      return;
    }
    let currentSubStep = subSteps[currentSubstepNr];
    currentSubStep = jsonReplaceDbActionVariables(ctx, currentSubStep);
    const stepDef = stepDefinitionMap[currentSubStep.type];
    if (!stepDef) throw getUserError(`Invalid dashboard action step type ${currentSubStep.type}`);
    stepDef.execute(ctx, currentSubStep, () => {
      executeCurrentSubStep(ctx, currentSubstepNr + 1);
    });
  }

  const result = evalExpression(expr);
  if (result) {
    executeCurrentSubStep(ctx, 0);
  } else {
    onCompleted();
  }
}

const dbActionStepTypeCondition: TpDbActionStepTypeDefinition = {
  stepType: 'Condition',
  execute,
  getJsonSchema,
};

export default dbActionStepTypeCondition;
